import { createApp } from '@backstage/frontend-defaults';
import { catalogWithFullDescriptions } from './modules/catalog';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { signInModule } from './modules/signIn';

export default createApp({
  features: [catalogWithFullDescriptions, navModule, homeModule, signInModule],
});
